import React from "react";

export const ColorBar = (props: { className?: string; id?: string; a?: boolean }) => {
    return (
        <div id={props.id} className={`flex flex-col h-8 w-full ${props.className}`}>
            <div className="basis-1/4 bg-ryellow"></div>
            <div className="basis-1/4 bg-rred"></div>
            <div className="basis-1/4 bg-rblue"></div>
            <div className="basis-1/4 bg-rgreen"></div>
        </div>
    );
};
